/* istanbul ignore file */
import React from 'react';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

const EmptyQualificationLevelMessage = ({ sx }: { sx?: SxProps<Theme> }) => {
  return (
    <Typography
      component="span"
      sx={[
        { display: 'inline-block', padding: '5px 15px 26px', fontStyle: 'italic' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      Competencies are not defined for this level.
    </Typography>
  );
};

export default EmptyQualificationLevelMessage;
